export const getChartOption = (data) => {  
  if (!data.length) return {};
  
    const mes = [...new Set(data.map((item) => item.descripcion.substring(0, 3)))].reverse();
    const colors = ['#d1dc5a', '#e0f7e0', '#6ac5cb', '#45444e', '#a3b85b', '#3a6b74'];
  
    const series = [
      {
        name: "Cantidad Recolectada",
        type: "bar",
        stack: "total",
        barWidth: 15,
        data: mes.map((m, index) => {
          const item = data.find((d) => d.descripcion.startsWith(m));
          return {
            value:item && item.cantidad_recolectada !== 0 ? item.cantidad_recolectada : '',
            itemStyle: {
              color: '#BBCD21',
               
              borderRadius: 2,
            },
            label:{
              show: true,
              position: 'right',
            },
          };
        }),
      },
    ];
  
    return {
      title: {
        text: "Nfu Entregados Al Mes",
        left: "center",
        padding: [20, 10, 10, 10],
        textStyle: {
          fontSize: Math.max(window.innerWidth * 0.02, 16), 
        },
      },
      tooltip: {},
      yAxis: {
        type: "category",
        data: mes,
        name: "MESES",
        nameLocation: "middle",
        nameTextStyle: { fontSize: 11, padding: [0, 0, 30, 0] },
        axisLabel: { color: "#000000" },
        axisTick: { show: false },
      },
      xAxis: {
        type: "value",
        name: "N° DE RECOLECCIONES",
        nameLocation: "middle",
        nameTextStyle: { fontSize: 11, padding: [30, 0, 0, 0] },
        axisLabel: { color: "#000000" },
      },
      series,
    };
  };
  